import React from 'react';

function WalletRiskSkeleton() {
  const shimmer = 'animate-pulse bg-gray-200 dark:bg-gray-700 rounded';

  return (
    <div className="space-y-6">
      <div className={`h-8 w-64 ${shimmer}`} />
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((item) => (
          <div key={item} className={`h-32 ${shimmer}`} />
        ))}
      </div>
      <div className={`h-48 ${shimmer}`} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className={`h-56 ${shimmer}`} />
        <div className={`h-56 ${shimmer}`} />
      </div>
    </div>
  );
}

export default WalletRiskSkeleton;
